import { HighlightOff } from '@mui/icons-material';
import { Avatar, Box, Divider, IconButton, ListItem, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import Counter from '../common/Counter';
import CurrencyDisplay from '../common/CurrencyDisplay';

@inject('cartStore', 'menuStore')
@observer
class CartMenuItem extends Component {
  handleCountChange = (index, count) => {
    this.props.cartStore.setCartMenuQty(index, count);
  };

  render() {
    const { cartStore, menuStore, cartMenu, index } = this.props;
    return (
      <ListItem divider style={{ paddingLeft: '2px', paddingRight: '2px' }}>
        <Box sx={{ flexGrow: 1 }} style={{ margin: '8px' }}>
          <Grid2 container direction={'column'} spacing={2}>
            <Grid2 container direction={'row'}>
              <Grid2>
                <Avatar
                  src={menuStore.getImageUrl(
                    cartMenu.itemStoreCode,
                    cartMenu.pictureFileName1,
                    cartMenu.pictureFileName2,
                  )}
                  style={{ width: 70, height: 70 }}
                ></Avatar>
              </Grid2>
              <Grid2 container xs direction="column">
                <Grid2>
                  <Typography component="span" variant="subtitle1" color="textPrimary" style={{ fontWeight: 'bold' }}>
                    {cartMenu.name}
                  </Typography>
                </Grid2>
                <Grid2>
                  <Typography color="textSecondary" variant="body2">
                    {cartStore.getToppingNames(index)}
                    {cartStore.getSetMenuNames(index)}
                  </Typography>
                </Grid2>
              </Grid2>
            </Grid2>
            <Grid2 container direction={'row'} justifyContent="space-between">
              <Grid2>
                <Counter
                  count={cartMenu.qty}
                  max={cartStore.getCartMenuMaxQty(index)}
                  onCountChange={count => this.handleCountChange(index, count)}
                  onMaxExceeded={() => cartStore.showPurchaseLimitMessage(index)}
                />
              </Grid2>
              <Grid2 container alignItems={'center'} justifyContent={'center'}>
                <Grid2 item xs style={{ fontWeight: 'bold' }}>
                  <CurrencyDisplay amount={menuStore.getMenuAmountInfo(cartMenu, cartMenu.qty).totalAmount} />
                </Grid2>
                <Grid2>
                  <IconButton size="small" onClick={() => cartStore.removeItemInCart(index)}>
                    <HighlightOff />
                  </IconButton>
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
        </Box>
        <Divider />
      </ListItem>
    );
  }
}

export default CartMenuItem;
